module.exports = __webpack_public_path__ + "static/koncer_referencja-6d2bd57334e8b02f84f15120d59ba6a3.pdf";